import React from 'react';

export default function Loading({ additionalData }: {
  additionalData: {
    usps?: string;
    salesCard?: string;
    storeCard?: string;
  };
}) {
  const firstCount = additionalData.salesCard ? 7 : 8;
  const secondCount = additionalData.storeCard ? 4 : 8;
  const thirdCount = additionalData.storeCard ? 3 : 0;
  return (
    <>
      {Array.from({ length: firstCount }, (_, index) => (
        <div key={index} className="w-full flex">
          <div
            className="group/card w-full block h-full bg-gray-100 p-3 pt-9.25 lg:p-6 lg:pt-11.25 flex flex-col gap-4 w-full h-full animate-pulse"
          >
            <div className="block bg-gray-300 aspect-square w-full relative overflow-hidden" />
            <div className="flex flex-col items-center justify-center gap-1 lg:gap-2">
              <div className="bg-gray-300 w-full h-6" />
              <div className="bg-gray-300 w-full h-6" />
            </div>
          </div>
        </div>
      ))}
      {additionalData.salesCard
        && (
          <div
            key="sales-card-wrap"
            className="w-full aspect-320/418 flex"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: additionalData.salesCard }}
          />
        )}
      {additionalData.usps
        && (
          <div
            className="w-full py-7.5 col-span-full"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: additionalData.usps }}
          />
        )}
      {Array.from({ length: secondCount }, (_, index) => (
        <div key={index} className="w-full flex">
          <div
            className="group/card w-full block h-full bg-gray-100 p-3 pt-9.25 lg:p-6 lg:pt-11.25 flex flex-col gap-4 w-full h-full animate-pulse"
          >
            <div className="block bg-gray-300 aspect-square w-full relative overflow-hidden" />
            <div className="flex flex-col items-center justify-center gap-1 lg:gap-2">
              <div className="bg-gray-300 w-full h-6" />
              <div className="bg-gray-300 w-full h-6" />
            </div>
          </div>
        </div>
      ))}
      {additionalData.storeCard
        && (
          <div
            className="w-full aspect-320/418 flex"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: additionalData.storeCard }}
          />
        )}
      {Array.from({ length: thirdCount }, (_, index) => (
        <div key={index} className="w-full flex">
          <div
            className="group/card w-full block h-full bg-gray-100 p-3 pt-9.25 lg:p-6 lg:pt-11.25 flex flex-col gap-4 w-full h-full animate-pulse"
          >
            <div className="block bg-gray-300 aspect-square w-full relative overflow-hidden" />
            <div className="flex flex-col items-center justify-center gap-1 lg:gap-2">
              <div className="bg-gray-300 w-full h-6" />
              <div className="bg-gray-300 w-full h-6" />
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
